module.exports = __webpack_public_path__ + "media/images/athletes/488-505d2bb2eeafe0e3c03f3b516ca51845.png";